import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Divider, Form } from "semantic-ui-react";
import axios from "axios";

const FeaturedHome = () => {
    const [data, setData] = useState([]);
    const MAX_IMAGE = 1 * 1024 * 1024
    const MAX_VIDEO = 10 * 1024 * 1024
    const [initialData, setInitialData] = useState([])
    const [loading, setLoading] = useState(false)
    const isChanged = JSON.stringify(data) !== JSON.stringify(initialData)

    const guidelineStyle = {
        background: "#f9f9f9",
        border: "1px solid #eee",
        borderRadius: "6px",
        padding: "8px 10px",
        fontSize: "0.85rem",
        color: "#666",
        marginTop: "8px",
        minHeight: "120px" // 🔥 samain tinggi
    }

    // 🔥 fetch data dari DB
    const getData = () => {
        axios.get(`${global.SRV}api_hoops_cms/controler/featured.php?index=1`)
        .then(res => {
            if (res.data.state === 200) {
                setData(res.data.data)
                setInitialData(JSON.parse(JSON.stringify(res.data.data))) // deep copy
            }
        })
    }

    useEffect(() => {
        getData()
    }, [])

    // 🔥 handle change per item
    const handleChange = (i, field, value) => {
        const newData = [...data]
        newData[i][field] = value
        setData(newData)
    }

    // 🔥 handle file
    const handleImageChange = (i, file) => {
        const newData = [...data]
        newData[i].image = file
        setData(newData)
    }

    const handleVideoChange = (i, file) => {
        const newData = [...data]
        newData[i].video = file
        setData(newData)
    }

    // 🔥 submit semua
    const handleSubmit = () => {
        setLoading(true)
        const param = new FormData()

        data.forEach((item, i) => {
            param.append(`data[${i}][id_featured]`, item.id_featured)
            param.append(`data[${i}][position]`, item.position)
            param.append(`data[${i}][information]`, item.information || '')
            param.append(`data[${i}][url]`, item.url || '')
            param.append(`data[${i}][is_video]`, item.is_video)

            if (item.image instanceof File) {
                param.append(`image_${item.position}`, item.image)
            }

            if (item.video instanceof File) {
                param.append(`video_${item.position}`, item.video)
            }
        })

        axios({
            method: "POST",
            url: `${global.SRV}api_hoops_cms/controler/featured.php?index=2`,
            headers: { 'Content-Type': 'multipart/form-data' },
            data: param
        })
        .then(res => {
            if (res.data.state === 200) {
                alert("Success update featured!")
                getData()
            } else {
                alert(res.data.error)
            }
        })
        .catch(() => {
            alert("Something went wrong")
        })
        .finally(() => {
            setLoading(false)
        })
    }

    return (
        <Container fluid style={{paddingBottom: '10em'}}>
            <Row className="mt-1 mb-3">
                <div className="text-facebook h3 mb-0">Edit Featured Home</div>
                <div className="text-muted">Manage featured section</div>
            </Row>
            <Divider />

            <Form onSubmit={handleSubmit}>
                <Row className="d-flex justify-content-center">
                    {data.map((item, i) => (
                        <Col xl={4} lg={6} md={12} key={item.position} className="mb-4">
                            <div className="p-3 border rounded">
                                <h5>{item.position.toUpperCase()}</h5>

                                <Form.Input
                                    label="Information"
                                    value={item.information || ''}
                                    onChange={(e, { value }) => handleChange(i, "information", value)}
                                />

                                <Form.Input
                                    label="URL"
                                    value={item.url || ''}
                                    onChange={(e, { value }) => handleChange(i, "url", value)}
                                />

                                <Form.Select
                                    label="Type"
                                    options={[
                                        { key: 'image', value: 'N', text: 'Image' },
                                        { key: 'video', value: 'Y', text: 'Video' }
                                    ]}
                                    value={item.is_video}
                                    onChange={(e, { value }) => handleChange(i, "is_video", value)}
                                />

                                {item.is_video === 'N' ? (
                                    <>
                                        <Form.Input
                                            type="file"
                                            label="Image"
                                            onChange={(e) => {
                                                const file = e.target.files[0]

                                                if (file && file.size > MAX_IMAGE) {
                                                    alert("Image max 1MB")
                                                    e.target.value = null // 🔥 reset input
                                                    return
                                                }

                                                handleImageChange(i, file)
                                            }}
                                        />
                                        <div style={guidelineStyle}>
                                            <strong>Image Guidelines:</strong><br />
                                            • Max 1MB<br />
                                            • JPG/PNG format<br />
                                            • Aspect ratio 9:16<br />
                                        </div>
                                        {item.image && typeof item.image === "string" && (
                                            <img src={item.image} alt="" style={{ width: "100%", marginTop: 10 }} />
                                        )}
                                    </>
                                ) : (
                                    <>
                                        <Form.Input
                                            type="file"
                                            label="Video"
                                            onChange={(e) => {
                                                const file = e.target.files[0]

                                                if (file && file.size > MAX_VIDEO) {
                                                    alert("Video max 10MB")
                                                    e.target.value = null
                                                    return
                                                }

                                                handleVideoChange(i, file)
                                            }}
                                        />
                                        <div style={guidelineStyle}>
                                            <strong>Video Guidelines:</strong><br />
                                            • Max 10MB<br />
                                            • MP4 format<br />
                                            • Aspect ratio 9:16<br />
                                            • Recommended ≤ 15 seconds
                                        </div>
                                        {item.video && typeof item.video === "string" && (
                                            <video src={item.video} style={{ width: "100%", marginTop: 10 }} controls />
                                        )}
                                    </>
                                )}
                            </div>
                        </Col>
                    ))}
                </Row>

                <div className="text-center mt-3 mb-10">
                    <Form.Button 
                        content={loading ? "Updating..." : "Update Featured"} 
                        color="facebook"
                        disabled={!isChanged || loading}
                    />
                </div>
            </Form>
        </Container>
    )
}

export default FeaturedHome;